// @ts-nocheck
import { useRouter } from 'next/router';
import styles from './CustomerZoneHome.module.css';

interface Props {
  companyName?: string;
  logoUrl?: string | null;
  expanded?: boolean;
}

const signupUrl = import.meta.env.VITE_CZ_SIGNUP_URL || 'https://servcraft.co.za/sign-up';

export default function CustomerZoneHero({ companyName, logoUrl, expanded }: Props) {
  const router = useRouter();
  const { t, c } = router.query;
  const base = t ? `?t=${t}&c=${c}` : '';

  return (
    <header className={`${styles.hero}${expanded ? ` ${styles.heroCollapsed}` : ''}`}>
      <div className={styles.navBar}>
        <a href={`/customerzone${base}`}>
          <img className={styles.logoImg} src="/logo-type-white.svg" alt="ServCraft" onError={(e: any) => { e.target.style.display = 'none'; }} />
        </a>
        <div className={styles.navActions}>
          <a className={styles.btnGhost} href={signupUrl} target="_blank" rel="noopener">
            <span className={styles.ctaLong}>Start your free trial</span>
            <span className={styles.ctaShort}>Free trial</span>
          </a>
          <a className={styles.btnSolid} href="/login">Sign in</a>
        </div>
      </div>
      <div className={`${styles.heroCopy}${expanded ? ` ${styles.heroCopyCollapsed}` : ''}`}>
        <span className={styles.heroCrest}>
          {logoUrl ? (
            <img src={logoUrl} alt={companyName || ''} />
          ) : (
            <span className={styles.heroCrestFallback}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="3" /><path d="M9 9h.01M15 9h.01M9 15h6" />
              </svg>
            </span>
          )}
        </span>
        {companyName && (
          <p className={styles.heroTitle}>{companyName} customer portal</p>
        )}
        <p className={styles.heroSub}>Track your ongoing jobs, approve quotes, and view invoices in one place.</p>
      </div>
      <svg className={`${styles.heroWave}${expanded ? ` ${styles.heroWaveCollapsed}` : ''}`} viewBox="0 0 1440 40" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0 24 C 300 36, 620 38, 960 26 C 1180 18, 1320 14, 1440 22 L1440 40 L0 40 Z" fill="#F5F8FB" />
      </svg>
    </header>
  );
}
